import { ReferanceAsyncSelect } from './referance-async-select'

const blacklist = Array.from(
  { length: 39 - 19 + 1 },
  (_, i) => `WPZCALL${String(i + 19).padStart(3, '0')}`
).filter((code) => !['WPZCALL022', 'WPZCALL023'].includes(code))

export function SelectReferanceCode10({ name }) {
  return (
    <ReferanceAsyncSelect
      name={name}
      labelCategory="EKSTRA KARTI"
      extraFilter={(option) => !blacklist.includes(option.label)}
    />
  )
}
